module.exports = __webpack_public_path__ + "img/4200.9c20ccb9.jpg";